import angular from 'angular';
import scenes from './scenes';
import components from './components';

export default angular.module('scenes.contactLendingTab', [scenes, components])
  .name;
